import { DeleteFeedItemBar } from "./DeleteFeedItemBar";

export default DeleteFeedItemBar;
